var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{ref:"mapWindow",staticClass:"map-block",attrs:{"id":"mapWindow"}},[_c('loading',{attrs:{"active":_vm.inModulation,"is-full-page":false},on:{"update:active":function($event){_vm.inModulation=$event}}}),_c('b-list-group',{ref:"instatllationMenu",staticStyle:{"position":"fixed","top":"0px","left":"0px","display":"none","z-index":"999999"}},[_c('b-list-group-item',{staticClass:"p-2 d-flex justify-content-between align-items-center"},[_vm._v("Название\n      "),_c('b-btn',{staticClass:"p-0 m-0",attrs:{"sise":"sm","variant":"outline-danger"},on:{"click":function($event){_vm.clearAll();
          _vm.$refs.instatllationMenu.style.display = 'none';}}},[_c('i',{staticClass:"fa fa-close p-0 m-0"})])],1),_c('b-list-group-item',{attrs:{"href":"#"},on:{"click":function($event){return _vm.$refs.installationToMap.show()}}},[_vm._v("Изменить объект")]),_c('b-list-group-item',{attrs:{"href":"#"},on:{"click":function($event){return _vm.$refs.installationToMap.show()}}},[_vm._v("Присоеденить трубопровод")]),_c('b-list-group-item',{attrs:{"href":"#"},on:{"click":function($event){return _vm.$refs.installationToMap.show()}}},[_vm._v("Присоеденить гибкое соединение")]),_c('b-list-group-item',{attrs:{"href":"#"},on:{"click":function($event){return _vm.$refs.installationToMap.show()}}},[_vm._v("Изменить точку")]),_c('b-list-group-item',{attrs:{"href":"#"}},[_vm._v("Удалить точку")])],1),_c('layers-menu',{attrs:{"layers":_vm.layers,"projectStatus":_vm.project.status},on:{"onDropdownChange":_vm.handleDropdownChange,"onLayerButtonClick":_vm.handleLayerButtonClick}}),_c('risk-panel',{attrs:{"analyse":_vm.analyse,"selectValue":_vm.analyse.factor},on:{"onFilterButtonClick":_vm.handleFilterButtonClick,"onRiskSelectChange":_vm.handleRiskSelectChange}}),_c('range-inputs-panel',{attrs:{"opacity":_vm.opacity,"project":_vm.project},on:{"onIconScaleChange":_vm.handleIconScaleChange,"onOpacityChange":_vm.handleOpacityChange}}),(!_vm.analyse.factor || _vm.analyse.factor == 0 || _vm.tourStep == 16)?_c('risk-info',{attrs:{"oldData":_vm.oldData,"maxIndRisk":_vm.maxIndRisk,"legalIndRisk":_vm.$parent.legalIndRisk,"toNormal":_vm.$parent.toNormal,"maxIndRiskRes":_vm.maxIndRiskRes,"legalResIndRisk":_vm.$parent.legalResIndRisk,"legalResSocRisk":_vm.$parent.legalResSocRisk,"maxSocialRisk":_vm.maxSocialRisk}}):_vm._e(),(_vm.substrate)?_c('div',{ref:"map",staticClass:"map",staticStyle:{"border-radius":"5px"},on:{"dragover":function($event){$event.stopPropagation();return _vm.allowDrop($event)},"drop":function($event){$event.preventDefault();return _vm.drop($event)},"mouseover":function($event){return _vm.toggleHtmlClass('addClass', 'disScroll')},"mouseleave":function($event){return _vm.toggleHtmlClass('removeClass', 'disScroll')},"mousemove":function($event){_vm.cursor = _vm.getScaledPointerPosition()},"contextmenu":function($event){$event.preventDefault();}}},[_c('v-stage',{ref:"mapLayer",attrs:{"config":Object.assign({}, _vm.configKonva,
        {
          dragBoundFunc: function dragBoundFunc(pos) {
            return {
              x: pos.x,
              y: pos.y,
            };
          },
        })},on:{"wheel":_vm.zoom,"click":function($event){return _vm.mapAction()}}},[_c('v-layer',{attrs:{"config":{ listening: false }}},[(_vm.substrate && _vm.substrateUrl && _vm.layers.substrate == 1)?_c('url-image',{ref:"sub",attrs:{"imageUrl":_vm.substrateUrl}}):_vm._e(),(_vm.zonesImage && _vm.layers.zones == 1)?_c('url-image',{attrs:{"config":{ opacity: 1 - Number(_vm.opacity), width: _vm.substrate.height, height: _vm.substrate.width },"width":_vm.substrate.width,"imageUrl":_vm.zonesImage}}):_vm._e()],1),_c('v-layer',{ref:"objectsLayer"},[_vm._l((_vm.dikingsWithoutExclude),function(diking,index){return _c('v-shape',{key:("dikings-" + index),attrs:{"config":{
            sceneFunc: _vm.shapeSceneFunc(diking),
            perfectDrawEnabled: false,
            fill: _vm.zones ? 0 : diking.focused ? '#0064ff' : '#00D2FF',
            stroke: 'black',
            strokeWidth: 4 * _vm.iconsScale,
            opacity: 0.5,
          }}})}),_vm._l((_vm.dikingsWithoutExclude),function(diking,d_index){return _c('span',{key:("d-" + d_index)},_vm._l((_vm.anchorsWithoutDeleted(diking.dots)),function(anchor,index){return _c('v-circle',{key:("anchor-" + index),attrs:{"config":{
              x: parseInt(anchor.x),
              y: parseInt(anchor.y),
              radius: 5 * _vm.iconsScale,
              stroke: '#666',
              fill: '#ddd',
              strokeWidth: 4 * _vm.iconsScale,
              draggable: true,
              dragBoundFunc: function dragBoundFunc(pos) {
                _vm.dikings[d_index].dots[index].x = _vm.getScaledPointerPosition().x;
                _vm.dikings[d_index].dots[index].y = _vm.getScaledPointerPosition().y;
                return {
                  x: pos.x,
                  y: pos.y,
                };
              },
            }},on:{"mousedown":function($event){return _vm.showDikingNodeWindow(diking, index)},"dragEnd":function($event){return _vm.dikingNewPos(diking)},"mouseover":function($event){return _vm.anchorOver(index)},"mouseout":function($event){return _vm.anchorOut(index)}}})}),1)}),(_vm.newDiking && !_vm.newDiking.diking_id)?_c('v-shape',{attrs:{"config":{
            sceneFunc: _vm.shapeSceneFuncV2(_vm.newDiking),
            perfectDrawEnabled: false,
            fill: 'red',
            stroke: 'black',
            strokeWidth: 4 * _vm.iconsScale,
            opacity: 0.5,
          }}}):_vm._e(),(_vm.newDiking && _vm.newDiking.dots && _vm.newDiking.dots.length == 1 && !_vm.newDiking.diking_id)?_c('v-circle',{attrs:{"config":{
            x: _vm.newDiking.dots[0].x,
            y: _vm.newDiking.dots[0].y,
            radius: 5,
            stroke: '#666',
            fill: '#666',
            strokeWidth: 4,
          }}}):_vm._e(),_vm._l((_vm.solidWithoutExclude),function(solid,index){return _c('v-shape',{key:("solid-" + index),attrs:{"config":{
            sceneFunc: _vm.shapeSceneFunc(solid),
            perfectDrawEnabled: false,
            fill: 'red',
            stroke: 'black',
            strokeWidth: 4 * _vm.iconsScale,
            opacity: 0.5,
          }}})}),_vm._l((_vm.solidWithoutExclude),function(solid,d_index){return _c('span',{key:("s-" + d_index)},_vm._l((_vm.anchorsWithoutDeleted(solid.dots)),function(anchor,index){return _c('v-circle',{key:("an-" + index),attrs:{"config":{
              x: parseInt(anchor.x),
              y: parseInt(anchor.y),
              radius: 5 * _vm.iconsScale,
              stroke: '#666',
              fill: '#ddd',
              strokeWidth: 4 * _vm.iconsScale,
              draggable: true,
              dragBoundFunc: function dragBoundFunc(pos) {
                _vm.solids[d_index].dots[index].x = _vm.getScaledPointerPosition().x;
                _vm.solids[d_index].dots[index].y = _vm.getScaledPointerPosition().y;
                return {
                  x: pos.x,
                  y: pos.y,
                };
              },
            }},on:{"mousedown":function($event){return _vm.showSolidNodeWindow(solid, index)},"dragEnd":function($event){return _vm.solidNewPos(solid)},"mouseover":function($event){return _vm.anchorOver(index)},"mouseout":function($event){return _vm.anchorOut(index)}}})}),1)}),(_vm.newSolid && !_vm.newSolid.id)?_c('v-shape',{attrs:{"config":{
            sceneFunc: _vm.shapeSceneFuncV2(_vm.newSolid),
            perfectDrawEnabled: false,
            fill: 'red',
            stroke: 'black',
            strokeWidth: 4 * _vm.iconsScale,
            opacity: 0.5,
          }}}):_vm._e(),(_vm.newSolid && _vm.newSolid.dots && _vm.newSolid.dots.length == 1 && !_vm.newSolid.id)?_c('v-circle',{attrs:{"config":{
            x: _vm.newSolid.dots[0].x,
            y: _vm.newSolid.dots[0].y,
            radius: 5,
            stroke: '#666',
            fill: '#666',
            strokeWidth: 4,
          }}}):_vm._e(),(_vm.newFirewall)?_c('v-line',{attrs:{"config":{
            sceneFunc: _vm.shapeBuildingSceneFunc(_vm.newFirewall),
            perfectDrawEnabled: false,
            stroke: 'black',
            strokeWidth: 4 * _vm.iconsScale,
            opacity: 0.5,
          }}}):_vm._e(),(_vm.newFirewall && _vm.newFirewall.dots && _vm.newFirewall.dots.length == 1)?_c('v-circle',{attrs:{"config":{
            x: _vm.newFirewall.dots[0].x,
            y: _vm.newFirewall.dots[0].y,
            radius: 5 * _vm.iconsScale,
            stroke: '#666',
            fill: '#666',
            strokeWidth: 4,
          }}}):_vm._e(),(_vm.newPipeline)?_c('v-line',{attrs:{"config":{
            sceneFunc: _vm.shapeBuildingSceneFunc(_vm.newPipeline),
            perfectDrawEnabled: false,
            stroke: 'black',
            strokeWidth: 4 * _vm.iconsScale,
            opacity: 0.5,
          }}}):_vm._e(),(_vm.newPipeline && _vm.newPipeline.dots && _vm.newPipeline.dots.length == 1)?_c('v-circle',{attrs:{"config":{
            x: _vm.newPipeline.dots[0].x,
            y: _vm.newPipeline.dots[0].y,
            radius: 5 * _vm.iconsScale,
            stroke: '#666',
            fill: '#666',
            strokeWidth: 4,
          }}}):_vm._e(),(_vm.newPipeline)?_c('v-line',{attrs:{"config":{
            sceneFunc: _vm.shapeBuildingSceneFunc(_vm.newPipeline),
            perfectDrawEnabled: false,
            stroke: 'black',
            strokeWidth: 4 * _vm.iconsScale,
            opacity: 0.5,
          }}}):_vm._e(),(_vm.newPipeline && _vm.newPipeline.dots && _vm.newPipeline.dots.length == 1)?_c('v-circle',{attrs:{"config":{
            x: _vm.newPipeline.dots[0].x,
            y: _vm.newPipeline.dots[0].y,
            radius: 5 * _vm.iconsScale,
            stroke: '#666',
            fill: '#666',
            strokeWidth: 4,
          }}}):_vm._e(),(_vm.newRoadDots)?_c('v-line',{attrs:{"config":{
            sceneFunc: _vm.shapeRoadSceneFunc(_vm.newRoadDots),
            perfectDrawEnabled: false,
            stroke: 'black',
            strokeWidth: 4 * _vm.iconsScale,
            opacity: 0.5,
            dash: [20, 10],
          }}}):_vm._e(),(_vm.newRoadDots && _vm.newRoadDots.length == 1)?_c('v-circle',{attrs:{"config":{
            x: _vm.newRoadDots[0].x,
            y: _vm.newRoadDots[0].y,
            radius: 5 * _vm.iconsScale,
            stroke: '#666',
            fill: '#666',
            strokeWidth: 4,
          }}}):_vm._e(),_vm._l((_vm.installationWithoutExclude),function(installation,index){return _c('span',{key:installation.id},[_vm._l((_vm.installationObjectsWithoutexclude(installation.mapObjects)),function(object,o_index){return _c('span',{key:object.id},[(_vm.layers.pipelines == 1)?_vm._l((object.pipelines),function(pipeline,personIndex){return _c('pipeline',{key:pipeline.id,attrs:{"mapLayer":_vm.$refs.mapLayer,"pipeline":pipeline,"dots":pipeline.dots,"startX":object.pipeStartLat ? object.pipeStartLat : parseInt(object.lat),"startY":object.pipeStartLng ? object.pipeStartLng : parseInt(object.lng),"iconsScale":_vm.iconsScale,"color":installation.color},on:{"pipelineFocus":function($event){return _vm.pipelineFocus(index, o_index, personIndex)},"showPipelineNodeWindow":function($event){return _vm.showPipelineNodeWindow($event)},"pipelineNewPos":function($event){return _vm.pipelineNewPos($event)}}})}):_vm._e()],2)}),_vm._l((_vm.installationObjectsWithoutexclude(installation.mapObjects)),function(object,o_index){return _c('v-group',{key:o_index,attrs:{"config":{
              x: parseFloat(object.lat),
              y: parseFloat(object.lng),
              draggable: true,
              dragBoundFunc: function dragBoundFunc(pos) {
                object.pipeStartLat = _vm.getScaledPointerPosition().x;
                object.pipeStartLng = _vm.getScaledPointerPosition().y;

                return {
                  x: pos.x,
                  y: pos.y,
                };
              },
            }},on:{"dragend":function($event){return _vm.objectNewPos(object.id, index, o_index, 'installation')}}},[(1 != 1)?_c('url-image',{attrs:{"config":{
                src: _vm.$parent.getInstallationImage(installation.obj_type),
                width: 96,
                height: 96,
                offsetX: 48,
                offsetY: 48,
              }}}):_vm._e(),_c('v-circle',{attrs:{"config":{
                radius: object.focused ? 25 * _vm.iconsScale : 16 * _vm.iconsScale,
                fill: installation.color,
                stroke: 'black',
                strokeWidth: 0,
                stroke: 'black',
                strokeWidth: 3 * _vm.iconsScale,
              }}}),_c('v-label',[_c('v-text',{attrs:{"config":{
                  text: object.icon_text,
                  fontSize: 20 * _vm.iconsScale,
                  lineHeight: 1.2,
                  padding: -9 * _vm.iconsScale,
                  ellipsis: true,
                  fill: 'white',
                }}})],1)],1)})],2)}),(_vm.layers.pipelines == 1)?_c('span',_vm._l((_vm.pipelines),function(pipeline,personIndex){return _c('pipeline',{key:pipeline.id,attrs:{"mapLayer":_vm.$refs.mapLayer,"pipeline":pipeline,"dots":pipeline.dots,"startX":pipeline.dots[0].x,"startY":pipeline.dots[0].y,"iconsScale":_vm.iconsScale,"color":pipeline.color},on:{"pipelineFocus":function($event){return _vm.pipelineFocus(_vm.index, _vm.o_index, personIndex)},"showPipelineNodeWindow":function($event){return _vm.showPipelineNodeWindow($event)},"pipelineNewPos":function($event){return _vm.pipelineNewPos($event)}}})}),1):_vm._e(),(_vm.layers.people == 1)?_c('span',_vm._l((_vm.people),function(person,index){return _c('span',{key:("people-" + index)},_vm._l((person.mapObjects),function(object,o_index){return _c('v-group',{key:("lat-" + o_index),attrs:{"config":{
                draggable: true,
                x: object.lat,
                y: object.lng,
                dragBoundFunc: function dragBoundFunc(pos) {
                  object.lat = _vm.getScaledPointerPosition().x;
                  object.lng = _vm.getScaledPointerPosition().y;
                  return {
                    x: pos.x,
                    y: pos.y,
                  };
                },
              }},on:{"dragend":function($event){return _vm.objectNewPos(object.id, index, o_index, 'people')}}},[(1 != 1)?_c('url-image',{attrs:{"config":{
                  src: require('../../assets/icons/engineer123.png'),
                  width: 96,
                  height: 96,
                  offsetX: 48,
                  offsetY: 80,
                }}}):_vm._e(),_c('v-regular-polygon',{attrs:{"config":{
                  sides: 3,
                  radius: object.focused ? 30 * _vm.iconsScale : 20 * _vm.iconsScale,
                  fill: person.color,
                  stroke: 'black',
                  strokeWidth: 3 * _vm.iconsScale,
                }}}),_c('v-label',[_c('v-text',{attrs:{"config":{
                    text: object.icon_text,
                    fontSize: 20 * _vm.iconsScale,
                    lineHeight: 1,
                    padding: -7 * _vm.iconsScale,
                    ellipsis: true,
                    fill: 'white',
                  }}})],1)],1)}),1)}),0):_vm._e(),_vm._l((_vm.filteredResidentialTypeOne),function(building){return [_c('v-line',{key:("building-" + (building.id)),attrs:{"config":{
              sceneFunc: _vm.shapeBuildingSceneFunc(building),
              perfectDrawEnabled: false,
              stroke: 'white',
              strokeWidth: 4 * _vm.iconsScale + 20,
              opacity: 0.8,
            }}}),_c('v-line',{key:("bu-" + (building.id)),attrs:{"config":{
              sceneFunc: _vm.shapeBuildingSceneFunc(building),
              perfectDrawEnabled: false,
              stroke: building.color,
              strokeWidth: 4 * _vm.iconsScale,
              opacity: 0.5,
              dash: [20, 10],
            }}}),_vm._l((building.dots),function(dot,i){return _c('v-regular-polygon',{key:("b1-" + (dot.x + i)),attrs:{"config":{
              sides: 5,
              radius: building.focused ? 30 * _vm.iconsScale : 20 * _vm.iconsScale,
              fill: building.color,
              stroke: 'black',
              strokeWidth: 3 * _vm.iconsScale,
              x: parseInt(dot.x),
              y: parseInt(dot.y),
            }}})}),_vm._l((building.dots),function(dot,i){return _c('v-label',{key:("b2-" + (dot.y + i))},[_c('v-text',{attrs:{"config":{
                text: building.icon_text,
                fontSize: 20 * _vm.iconsScale,
                lineHeight: 1,
                padding: -7 * _vm.iconsScale,
                ellipsis: true,
                fill: 'white',
                x: parseInt(dot.x),
                y: parseInt(dot.y),
              }}})],1)})]}),_vm._l((_vm.residential),function(building){return (parseInt(building.exclude) != 1 && building.type == 4 && _vm.layers.buildings == 1)?[_c('v-line',{attrs:{"config":{
              sceneFunc: function (context, shape) {
                context.beginPath();

                for (var i in building.dots) {
                  context.lineTo(building.dots[i].x, building.dots[i].y);
                }
                // special Konva.js method
                context.fillStrokeShape(shape);
              },
              perfectDrawEnabled: false,
              stroke: 'white',
              strokeWidth: 4 * _vm.iconsScale + 5,
              opacity: 0.8,
            }}}),_c('v-line',{attrs:{"config":{
              sceneFunc: function (context, shape) {
                context.beginPath();

                for (var i in building.dots) {
                  context.lineTo(building.dots[i].x, building.dots[i].y);
                }
                // special Konva.js method
                context.fillStrokeShape(shape);
              },
              perfectDrawEnabled: false,
              stroke: building.color,
              strokeWidth: 4 * _vm.iconsScale + 5,
              opacity: 0.5,
              dash: [20, 20],
            }}}),_vm._l((building.dots),function(dot){return _c('v-regular-polygon',{attrs:{"config":{
              sides: 5,
              radius: building.focused ? 30 * _vm.iconsScale : 20 * _vm.iconsScale,
              fill: building.color,
              stroke: 'black',
              strokeWidth: 3 * _vm.iconsScale,
              x: parseInt(dot.x),
              y: parseInt(dot.y),
            }}})}),_vm._l((building.dots),function(dot){return _c('v-label',[_c('v-text',{attrs:{"config":{
                text: building.icon_text,
                fontSize: 20 * _vm.iconsScale,
                lineHeight: 1,
                padding: -7 * _vm.iconsScale,
                ellipsis: true,
                fill: 'white',
                x: parseInt(dot.x),
                y: parseInt(dot.y),
              }}})],1)})]:_vm._e()}),_vm._l((_vm.residential),function(building,index){return (
            parseInt(building.exclude) != 1 && (building.type == 1 || building.type == 2) && _vm.layers.buildings == 1
          )?[_c('v-group',{attrs:{"config":{ draggable: true, x: parseInt(building.lat), y: parseInt(building.lng) }},on:{"dragend":function($event){return _vm.socialNewPos(building.id, index, 'residential')}}},[(1 != 1)?_c('url-image',{attrs:{"config":{
                src: require('../../assets/icons/hotel.png'),
                width: 96,
                height: 96,
                offsetX: 48,
                offsetY: 48,
              }}}):_vm._e(),_c('v-regular-polygon',{attrs:{"config":{
                sides: 5,
                radius: building.focused ? 30 * _vm.iconsScale : 20 * _vm.iconsScale,
                fill: building.color,
                stroke: 'black',
                strokeWidth: 3 * _vm.iconsScale,
              }}}),_c('v-label',[_c('v-text',{attrs:{"config":{
                  text: building.icon_text,
                  fontSize: 20 * _vm.iconsScale,
                  lineHeight: 1,
                  padding: -7 * _vm.iconsScale,
                  ellipsis: true,
                  fill: 'white',
                }}})],1)],1)]:_vm._e()}),_vm._l((_vm.firewalls),function(firewall,i){return (parseInt(firewall.exclude) != 1 && _vm.layers.firewalls == 1)?[_c('v-line',{key:("firewall-" + i),attrs:{"config":{
              sceneFunc: function (context, shape) {
                context.beginPath();

                for (var i in firewall.dots) {
                  context.lineTo(firewall.dots[i].x, firewall.dots[i].y);
                }
                // special Konva.js method
                context.fillStrokeShape(shape);
              },
              perfectDrawEnabled: false,
              stroke: 'white',
              strokeWidth: 4 * _vm.iconsScale + 5,
              opacity: 0.8,
            }}}),_c('v-line',{attrs:{"config":{
              sceneFunc: function (context, shape) {
                context.beginPath();

                for (var i in firewall.dots) {
                  context.lineTo(firewall.dots[i].x, firewall.dots[i].y);
                }
                // special Konva.js method
                context.fillStrokeShape(shape);
              },
              perfectDrawEnabled: false,
              stroke: 'red',
              strokeWidth: 4 * _vm.iconsScale + 5,
              opacity: 0.5,
              dash: [10, 2],
            }}})]:_vm._e()}),_vm._l((_vm.firewalls),function(firewall,d_index){return (parseInt(firewall.exclude) != 1 && _vm.layers.firewalls == 1)?_vm._l((firewall.dots),function(anchor,index){return (!anchor.deleted)?_c('v-circle',{attrs:{"config":{
              x: parseInt(anchor.x),
              y: parseInt(anchor.y),
              radius: 5 * _vm.iconsScale,
              stroke: '#666',
              fill: '#ddd',
              strokeWidth: 4 * _vm.iconsScale,
              draggable: true,
              dragBoundFunc: function dragBoundFunc(pos) {
                _vm.firewalls[d_index].dots[index].x = _vm.getScaledPointerPosition().x;
                _vm.firewalls[d_index].dots[index].y = _vm.getScaledPointerPosition().y;
                return {
                  x: pos.x,
                  y: pos.y,
                };
              },
            }},on:{"dragEnd":function($event){return _vm.firewallNewPos(firewall)},"mouseover":function($event){return _vm.anchorOver(index)},"mouseout":function($event){return _vm.anchorOut(index)}}}):_vm._e()}):_vm._e()}),(_vm.scale && _vm.scale[0])?_c('v-line',{attrs:{"config":{
            points: [parseInt(_vm.scale[0].x), parseInt(_vm.scale[0].y), _vm.cursor.x, _vm.cursor.y],
            stroke: 'black',
            strokeWidth: 4 * _vm.iconsScale,
          }}}):_vm._e(),(_vm.scale && _vm.scale[0] && _vm.action == 'ruler')?_c('v-label',{attrs:{"config":{ x: _vm.cursor.x, y: _vm.cursor.y, opacity: 0.75, fill: 'white' }}},[_c('v-tag',{attrs:{"config":{
              fill: 'black',
              pointerDirection: 'down',
              pointerWidth: 10 * _vm.iconsScale,
              pointerHeight: 10 * _vm.iconsScale,
              lineJoin: 'round',
              shadowColor: 'black',
              shadowBlur: 10 * _vm.iconsScale,
              shadowOffset: 10 * _vm.iconsScale,
              shadowOpacity: 0.5,
            }}}),_c('v-text',{attrs:{"config":{
              text: (
                Math.sqrt(
                  Math.pow(parseInt(this.scale[0].x) - this.cursor.x, 2) +
                    Math.pow(parseInt(this.scale[0].y) - this.cursor.y, 2)
                ) / _vm.substrate.k
              ).toFixed(2),
              fontFamily: 'Calibri',
              fontSize: 18 * _vm.iconsScale,
              padding: 5 * _vm.iconsScale,
              fill: 'white',
            }}})],1):_vm._e()],2),_c('v-layer',[(!_vm.oldData && _vm.currentRisk && _vm.currentRisk.risk)?_c('v-label',{attrs:{"config":{ x: _vm.currentRisk.lat, y: _vm.currentRisk.lng, opacity: 0.75, fill: 'white' }}},[_c('v-tag',{attrs:{"config":{
              fill: 'black',
              pointerDirection: 'down',
              pointerWidth: 10 * _vm.iconsScale,
              pointerHeight: 10 * _vm.iconsScale,
              lineJoin: 'round',
              shadowColor: 'black',
              shadowBlur: 10 * _vm.iconsScale,
              shadowOffset: 10 * _vm.iconsScale,
              shadowOpacity: 0.5,
            }}}),_c('v-text',{attrs:{"config":{
              text: _vm.toNormal(_vm.currentRisk.risk),
              fontFamily: 'Calibri',
              fontSize: 18 * _vm.iconsScale,
              padding: 5 * _vm.iconsScale,
              fill: 'white',
            }}})],1):_vm._e(),(_vm.pipelineNode && _vm.pipelineNode.show)?_c('nodeMenu',{attrs:{"pipeline":true,"object":_vm.pipelineNode},on:{"save":function($event){return _vm.pipelineNewPos($event)},"changeCursor":_vm.changeCursor}}):_vm._e(),(_vm.dikingNode && _vm.dikingNode.show)?_c('nodeMenu',{attrs:{"object":_vm.dikingNode},on:{"save":function($event){return _vm.dikingNewPos($event)},"changeCursor":_vm.changeCursor}}):_vm._e(),(_vm.solidNode && _vm.solidNode.show)?_c('nodeMenu',{attrs:{"object":_vm.solidNode},on:{"save":function($event){return _vm.solidNewPos($event)},"changeCursor":_vm.changeCursor}}):_vm._e()],1),_c('v-layer',{attrs:{"config":{ listening: true }}},[(_vm.newPipeline && _vm.newPipeline.dots && _vm.newPipeline.dots.length > 1)?_c('v-label',{attrs:{"config":{
            x: _vm.newPipeline.dots[_vm.newPipeline.dots.length - 1].x,
            y: _vm.newPipeline.dots[_vm.newPipeline.dots.length - 1].y,
            opacity: 0.75,
            fill: 'white',
          }},on:{"click":function($event){return _vm.pipelineFinish()}}},[_c('v-tag',{attrs:{"config":{
              fill: 'black',
              pointerDirection: 'down',
              pointerWidth: 10 * _vm.iconsScale,
              pointerHeight: 10 * _vm.iconsScale,
              lineJoin: 'round',
              shadowColor: 'black',
              shadowBlur: 10 * _vm.iconsScale,
              shadowOffset: 10 * _vm.iconsScale,
              shadowOpacity: 0.5,
            }}}),_c('v-text',{attrs:{"config":{
              text: 'Сохранить',
              fontFamily: 'Calibri',
              fontSize: 18 * _vm.iconsScale,
              padding: 5 * _vm.iconsScale,
              fill: 'white',
            }}})],1):_vm._e(),(_vm.newRoadDots && _vm.newRoadDots.length > 1)?_c('v-label',{attrs:{"config":{
            x: _vm.newRoadDots[_vm.newRoadDots.length - 1].x,
            y: _vm.newRoadDots[_vm.newRoadDots.length - 1].y,
            opacity: 0.75,
            fill: 'white',
          }},on:{"click":function($event){return _vm.socialRoadAdd()}}},[_c('v-tag',{attrs:{"config":{
              fill: 'black',
              pointerDirection: 'down',
              pointerWidth: 10 * _vm.iconsScale,
              pointerHeight: 10 * _vm.iconsScale,
              lineJoin: 'round',
              shadowColor: 'black',
              shadowBlur: 10 * _vm.iconsScale,
              shadowOffset: 10 * _vm.iconsScale,
              shadowOpacity: 0.5,
            }}}),_c('v-text',{attrs:{"config":{
              text: 'Сохранить',
              fontFamily: 'Calibri',
              fontSize: 18 * _vm.iconsScale,
              padding: 5 * _vm.iconsScale,
              fill: 'white',
            }}})],1):_vm._e(),(_vm.newPipeline && _vm.newPipeline.dots && _vm.newPipeline.dots.length > 1)?_c('v-label',{attrs:{"config":{
            x: _vm.newPipeline.dots[_vm.newPipeline.dots.length - 1].x,
            y: _vm.newPipeline.dots[_vm.newPipeline.dots.length - 1].y,
            opacity: 0.75,
            fill: 'white',
          }},on:{"click":function($event){return _vm.pipelineFinish()}}},[_c('v-tag',{attrs:{"config":{
              fill: 'black',
              pointerDirection: 'down',
              pointerWidth: 10 * _vm.iconsScale,
              pointerHeight: 10 * _vm.iconsScale,
              lineJoin: 'round',
              shadowColor: 'black',
              shadowBlur: 10 * _vm.iconsScale,
              shadowOffset: 10 * _vm.iconsScale,
              shadowOpacity: 0.5,
            }}}),_c('v-text',{attrs:{"config":{
              text: 'Сохранить',
              fontFamily: 'Calibri',
              fontSize: 18 * _vm.iconsScale,
              padding: 5 * _vm.iconsScale,
              fill: 'white',
            }}})],1):_vm._e(),(_vm.newDiking && _vm.newDiking.dots && _vm.newDiking.dots.length > 2 && !_vm.newDiking.diking_id)?_c('v-label',{attrs:{"config":{
            x: _vm.newDiking.dots[_vm.newDiking.dots.length - 1].x,
            y: _vm.newDiking.dots[_vm.newDiking.dots.length - 1].y,
            opacity: 0.75,
            fill: 'white',
          }},on:{"click":function($event){return _vm.dikingWindow()}}},[_c('v-tag',{attrs:{"config":{ fill: 'black', shadowOpacity: 0.5 }}}),_c('v-text',{attrs:{"config":{
              text: 'Сохранить',
              fontFamily: 'Calibri',
              fontSize: 18 * _vm.iconsScale,
              padding: 5 * _vm.iconsScale,
              fill: 'white',
            }}})],1):_vm._e(),(_vm.newSolid && _vm.newSolid.dots && _vm.newSolid.dots.length > 2 && !_vm.newSolid.id)?_c('v-label',{attrs:{"config":{
            x: _vm.newSolid.dots[_vm.newSolid.dots.length - 1].x,
            y: _vm.newSolid.dots[_vm.newSolid.dots.length - 1].y,
            opacity: 0.75,
            fill: 'white',
          }},on:{"click":function($event){return _vm.solidWindow()}}},[_c('v-tag',{attrs:{"config":{
              fill: 'black',
              pointerDirection: 'down',
              pointerWidth: 10 * _vm.iconsScale,
              pointerHeight: 10 * _vm.iconsScale,
              lineJoin: 'round',
              shadowColor: 'black',
              shadowBlur: 10 * _vm.iconsScale,
              shadowOffset: 10 * _vm.iconsScale,
              shadowOpacity: 0.5,
            }}}),_c('v-text',{attrs:{"config":{
              text: 'Сохранить',
              fontFamily: 'Calibri',
              fontSize: 18 * _vm.iconsScale,
              padding: 5 * _vm.iconsScale,
              fill: 'white',
            }}})],1):_vm._e(),(_vm.newFirewall && _vm.newFirewall.dots && _vm.newFirewall.dots.length > 1)?_c('v-label',{attrs:{"config":{
            x: _vm.newFirewall.dots[_vm.newFirewall.dots.length - 1].x,
            y: _vm.newFirewall.dots[_vm.newFirewall.dots.length - 1].y,
            opacity: 0.75,
            fill: 'white',
          }},on:{"click":function($event){return _vm.firewallWindow()}}},[_c('v-tag',{attrs:{"config":{
              fill: 'black',
              pointerDirection: 'down',
              pointerWidth: 10 * _vm.iconsScale,
              pointerHeight: 10 * _vm.iconsScale,
              lineJoin: 'round',
              shadowColor: 'black',
              shadowBlur: 10 * _vm.iconsScale,
              shadowOffset: 10 * _vm.iconsScale,
              shadowOpacity: 0.5,
            }}}),_c('v-text',{attrs:{"config":{
              text: 'Сохранить',
              fontFamily: 'Calibri',
              fontSize: 18 * _vm.iconsScale,
              padding: 5 * _vm.iconsScale,
              fill: 'white',
            }}})],1):_vm._e()],1)],1),_c('windRose',{staticStyle:{"position":"absolute","right":"24px","bottom":"24px"},attrs:{"project":_vm.project},on:{"rotation":_vm.handleRotation,"update:project":function($event){_vm.project=$event}}})],1):_c('upload-substrate',{on:{"onAdd":_vm.callInputEvent,"onMapUploadClick":function($event){return _vm.$bvModal.show('mapUpload')}}}),_c('modal-wrapper',{attrs:{"modalId":"pipelineConnect","hide-footer":"","title":_vm.pipelineConnectTitle,"dialogClass":"pipeline-connect-modal"},on:{"onCancelClick":function($event){return _vm.$bvModal.hide('pipelineConnect')}}},[_c('connectedPipeline',{attrs:{"showError":_vm.showError,"substrate":_vm.substrate,"newPipeline":_vm.newPipeline,"action":_vm.action,"installations":_vm.installations,"proj_id":_vm.project.id},on:{"pipelineWindowClose":function($event){return _vm.pipelineWindowClose()},"update:newPipeline":function($event){_vm.newPipeline=$event},"update:new-pipeline":function($event){_vm.newPipeline=$event},"update:action":function($event){_vm.action=$event},"pipelineConnect":function($event){return _vm.pipelineSave($event)},"onCancelClick":function($event){return _vm.$bvModal.hide('pipelineConnect')}}})],1),_c('b-modal',{ref:"installationToMap",attrs:{"id":"installationToMap","hide-footer":"","title":_vm.temp.isNewRecord ? 'Добавить технологическую установку на карту' : 'Изменить'}},[_c('center',[_c('b-row',{staticClass:"my-1"},[_c('b-col',{attrs:{"sm":"6"}},[_c('label',{attrs:{"for":"count"}},[_vm._v("Количество установок в точке:")])]),_c('b-col',{attrs:{"sm":"6"}},[(_vm.temp)?_c('b-form-input',{attrs:{"id":"count","type":"number"},model:{value:(_vm.temp.count),callback:function ($$v) {_vm.$set(_vm.temp, "count", $$v)},expression:"temp.count"}}):_vm._e(),(_vm.temp && _vm.temp.errors && _vm.temp.errors.count)?_c('div',{staticClass:"text-danger"},[_vm._v(_vm._s(_vm.temp.errors.count[0]))]):_vm._e()],1)],1),_c('b-row',{staticClass:"my-1"},[_c('b-col',{attrs:{"sm":"6"}},[_c('label',{attrs:{"for":"hours"}},[_vm._v("Время нахождения установки в точке (количество часов в сутки), ч:")])]),_c('b-col',{attrs:{"sm":"6"}},[_c('b-form-input',{attrs:{"id":"hours","type":"number"},model:{value:(_vm.temp.hours),callback:function ($$v) {_vm.$set(_vm.temp, "hours", $$v)},expression:"temp.hours"}}),(_vm.temp && _vm.temp.errors && _vm.temp.errors.hours)?_c('div',{staticClass:"text-danger"},[_vm._v(_vm._s(_vm.temp.errors.hours[0]))]):_vm._e()],1)],1),(_vm.temp)?_c('b-btn',{attrs:{"variant":"success"},on:{"click":function($event){$event.preventDefault();return _vm.installationToMap()}}},[(_vm.temp.isNewRecord)?_c('span',[_vm._v("Добавить")]):_c('span',[_vm._v("Сохранить")])]):_vm._e()],1)],1),_c('modal-wrapper',{attrs:{"modalId":"peopleToMap","hide-footer":"","title":_vm.temp.isNewRecord ? 'Добавить работника на карту' : 'Изменить'},on:{"onCancelClick":function($event){return _vm.$bvModal.hide('peopleToMap')}}},[_c('form',{staticClass:"modal-form"},[_c('custom-input',{attrs:{"required":"","inputType":"string","placeholder":"Время нахождения работника в точке","labelText":"Время нахождения работника в точке (количество часов в сутки), ч:","errorMessage":_vm.temp && _vm.temp.errors && _vm.temp.errors.hours ? _vm.temp.errors.hours[0] : '',"inputValue":_vm.temp.hours,"name":"hours"},model:{value:(_vm.temp.hours),callback:function ($$v) {_vm.$set(_vm.temp, "hours", $$v)},expression:"temp.hours"}})],1),_c('div',{staticClass:"modal-footer-buttons"},[_c('main-button',{attrs:{"type":"button"},on:{"click":function($event){return _vm.peopleToMap()}}},[(_vm.temp.isNewRecord)?_c('span',[_vm._v("Добавить")]):_c('span',[_vm._v("Сохранить")])]),_c('main-button',{attrs:{"color":"link","type":"button"},on:{"click":function($event){return _vm.$bvModal.hide('peopleToMap')}}},[_vm._v("Отмена")])],1)]),_c('modal-wrapper',{attrs:{"modalId":"socialAdd","hide-footer":"","title":"Добавить объект на прилегающей территории"},on:{"onCancelClick":function($event){return _vm.$bvModal.hide('socialAdd')}}},[_c('socialEdit',{attrs:{"project":_vm.project,"social":_vm.newSocial,"socials":_vm.residential},on:{"onCancelClick":function($event){return _vm.$bvModal.hide('socialAdd')},"socialEditHide":function($event){_vm.$bvModal.hide('socialAdd'); _vm.$emit('clearCalculations')},"socialCreated":function($event){_vm.socialCreated();
        _vm.$bvModal.hide('socialAdd');},"update:socials":function($event){_vm.residential=$event},"substrateUpdate":_vm.substrateUpdate}})],1),_c('modal-wrapper',{ref:"scale",attrs:{"modalId":"scale","title":"Масштаб","dialogClass":"modal-scale-wrapper"},on:{"onCancelClick":function($event){return _vm.clickCancelScaleModal()},"onSaveClick":function($event){return _vm.scaleSave(_vm.scale, _vm.temp.real_dist)}}},[_c('div',{staticClass:"modal-scale-input"},[_c('p',[_vm._v("Расстояние между точками, м")]),_c('b-form-input',{attrs:{"placeholder":"Введите значение"},model:{value:(_vm.temp.real_dist),callback:function ($$v) {_vm.$set(_vm.temp, "real_dist", $$v)},expression:"temp.real_dist"}}),_c('p',{staticClass:"text-danger"},[_vm._v(_vm._s(_vm.scale.error))])],1)]),_c('modal-wrapper',{attrs:{"modalId":"dikingToMap","hide-footer":"","title":"Добавить обвалование на карту"},on:{"onCancelClick":function($event){return _vm.$bvModal.hide('dikingToMap')}}},[_c('dikingEdit',{attrs:{"newDiking":_vm.newDiking,"substrate":_vm.substrate,"proj_id":_vm.project.id,"dikings":_vm.dikings},on:{"onCancelClick":function($event){return _vm.$bvModal.hide('dikingToMap')},"update:dikings":function($event){_vm.dikings=$event},"hide":function($event){_vm.newDiking = { dots: {} };
        _vm.$bvModal.hide('dikingToMap');},"clearCalculations":function($event){return _vm.$emit('clearCalculations')}}})],1),_c('modal-wrapper',{attrs:{"modalId":"firewallToMap","hideFooter":"","title":"Добавить противопожарную стену"},on:{"onCancelClick":function($event){return _vm.handleFirewallCancelClick()}}},[_c('firewallEdit',{attrs:{"newFirewall":_vm.newFirewall,"substrate":_vm.substrate,"proj_id":Number(_vm.project.id),"firewalls":_vm.firewalls},on:{"update:firewalls":function($event){_vm.firewalls=$event},"onCancelClick":function($event){return _vm.handleFirewallCancelClick()},"hide":function($event){return _vm.handleFirewallCancelClick()},"clearCalculations":function($event){return _vm.$emit('clearCalculations')}}})],1),_c('modal-wrapper',{ref:"mapUpload",attrs:{"dialogClass":"map-upload-wrapper","modalId":"mapUpload","hide-footer":"","title":"Использовать карту"},on:{"onCancelClick":function($event){return _vm.$bvModal.hide('mapUpload')}}},[_c('mapUpload',{attrs:{"substrate":_vm.substrate,"proj_id":Number(_vm.project.id),"city":_vm.project.city0},on:{"update:substrate":function($event){_vm.substrate=$event},"substrateUpdate":function($event){return _vm.substrateUpdate($event)},"onCancelClick":function($event){return _vm.$bvModal.hide('mapUpload')}}})],1),_c('modal-wrapper',{ref:"filter",attrs:{"dialogClass":"zones-filter-wrapper","modalId":"filter","hide-footer":"","title":"Фильтр"},on:{"onCancelClick":function($event){return _vm.$bvModal.hide('filter')}}},[_c('zonesFilter',{attrs:{"getZones":_vm.getZones,"installations":_vm.installations,"pipelines":_vm.pipelines,"analyse":_vm.analyse},on:{"onCancelClick":function($event){return _vm.$bvModal.hide('filter')},"update:analyse":function($event){_vm.analyse=$event}}})],1),_c('div',{staticClass:"toaster-wrapper"},_vm._l((_vm.toasts),function(ref){
        var content = ref.content;
        var title = ref.title;
        var id = ref.id;
        var autoHideDelay = ref.autoHideDelay;
        var type = ref.type;
        var noAutoHide = ref.noAutoHide;
return _c('custom-toast',{key:id,attrs:{"content":content,"title":title,"toastId":id,"autoHideDelay":autoHideDelay,"type":type,"noAutoHide":noAutoHide},on:{"onCloseClick":_vm.handleToastCloseClick}})}),1),_c('p',{staticClass:"rotation-angle"},[_vm._v(_vm._s(_vm.currentRotation ? _vm.currentRotation : Math.round(_vm.project.rotate))+"°")])],1)}
var staticRenderFns = []

export { render, staticRenderFns }